var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33073 3.47656C8.90528 3.47656 8.49725 3.64557 8.19641 3.94641C7.89557 4.24725 7.72656 4.65528 7.72656 5.08073C7.72656 5.50618 7.89557 5.91421 8.19641 6.21505C8.49725 6.51589 8.90528 6.6849 9.33073 6.6849C9.75618 6.6849 10.1642 6.51589 10.465 6.21505C10.7659 5.91421 10.9349 5.50618 10.9349 5.08073C10.9349 4.65528 10.7659 4.24725 10.465 3.94641C10.1642 3.64557 9.75618 3.47656 9.33073 3.47656Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8307 1.57812H1.16406V13.2448H12.8307V1.57812ZM11.6641 2.74479V11.8366L5.2474 5.41996L2.33073 8.33663V2.74479H11.6641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadImage);
export default __webpack_public_path__ + "static/media/icon_upload_image.5ece7372b759fbc13504b7f18d279e26.svg";
export { ForwardRef as ReactComponent };